import * as c from './constants'
import * as u from './util'
import s from './storage'

export const constants = c
export const util = u
export const storage = s

// window.addEventListener('unload', () => {
//   storage.B3IsInitDefaultAddresses.removeValue()
// })
